import React from 'react';
import type { Agent } from '../../lib/agent-types';

interface Props {
  agent: Agent;
  onEdit?: (agent: Agent) => void;
  onDelete?: (id: string) => void;
  onPublish?: (id: string) => void;
  onTest?: (agent: Agent) => void;
  showActions?: boolean;
}

export function AgentCard({ agent, onEdit, onDelete, onPublish, onTest, showActions = true }: Props) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-2">
        <div>
          <h3 className="font-semibold text-gray-900">{agent.name}</h3>
          {agent.published && (
            <span className="inline-block px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded mt-1">
              Published
            </span>
          )}
        </div>
        <span className="text-xs text-gray-500">{agent.model}</span>
      </div>
      
      {agent.description && (
        <p className="text-sm text-gray-600 mb-3 line-clamp-2">{agent.description}</p>
      )}
      
      <div className="flex flex-wrap gap-1 mb-3">
        <span className="px-2 py-0.5 text-xs bg-purple-50 text-purple-700 rounded">{agent.memory}</span>
        {agent.tools.slice(0, 3).map(tool => (
          <span key={tool} className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded">{tool}</span>
        ))}
        {agent.tools.length > 3 && (
          <span className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded">+{agent.tools.length - 3}</span>
        )}
      </div>
      
      {showActions && (
        <div className="flex gap-2 pt-2 border-t border-gray-100">
          {onEdit && (
            <button onClick={() => onEdit(agent)} className="text-sm text-blue-600 hover:text-blue-800">
              Edit
            </button>
          )}
          {onTest && (
            <button onClick={() => onTest(agent)} className="text-sm text-purple-600 hover:text-purple-800">
              Test
            </button>
          )}
          {onPublish && (
            <button onClick={() => onPublish(agent.id)} className="text-sm text-green-600 hover:text-green-800">
              {agent.published ? 'Unpublish' : 'Publish'}
            </button>
          )}
          {onDelete && (
            <button onClick={() => onDelete(agent.id)} className="text-sm text-red-600 hover:text-red-800">
              Delete
            </button>
          )}
        </div>
      )}
    </div>
  );
}
